/**
 * Find the same width of element and apply it to all group
 */

document.addEventListener('DOMContentLoaded', () => {
    var myNodeList = document.querySelectorAll('.dynamic-cta-actions');
    if(myNodeList != null && myNodeList != undefined && myNodeList.length > 1){

        myNodeList.forEach( function (container) {
            let max = 0;

            for (const child of container.children) {
                let current = child.getBoundingClientRect();
                if(current.width > max){
                    max = Math.ceil(current.width) + 0.5; //Buffer

                }
            }
            for (const child of container.children) {
                child.style.width = max + 'px';
            }
        });
    }
})





